var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        { staticClass: "labelDiv" },
        [
          _c(
            "el-col",
            { staticClass: "inputDiv", attrs: { span: 12 } },
            [
              _c("app-display", {
                class:
                  _vm.copararImovelSolicitacao &&
                  _vm.copararImovelSolicitacao.mudouDenominacao
                    ? "text"
                    : "",
                attrs: {
                  label: "Denominação:",
                  content: _vm.getValue(_vm.imovel.denominacao)
                }
              }),
              _c("app-display", {
                class:
                  _vm.copararImovelSolicitacao &&
                  _vm.copararImovelSolicitacao.mudouMunicipio
                    ? "text"
                    : "",
                attrs: {
                  label: "Município:",
                  content: _vm.getMunicipio(_vm.imovel.municipio)
                }
              }),
              _c("app-display", {
                class:
                  _vm.copararImovelSolicitacao &&
                  _vm.copararImovelSolicitacao.mudouArea
                    ? "text"
                    : "",
                attrs: { label: "Área:", content: _vm.area }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { staticClass: "inputDiv", attrs: { span: 12 } },
            [
              _c("app-display", {
                class:
                  _vm.copararImovelSolicitacao &&
                  _vm.copararImovelSolicitacao.mudouNomeColonia
                    ? "text"
                    : "",
                attrs: {
                  label: "Nome da colônia:",
                  content: _vm.getValue(_vm.imovel.nomeColonia)
                }
              }),
              _c("app-display", {
                class:
                  _vm.copararImovelSolicitacao &&
                  _vm.copararImovelSolicitacao.mudouLocalizacao
                    ? "text"
                    : "",
                attrs: {
                  label: "Localização:",
                  content: _vm.getValue(_vm.imovel.localizacao)
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c("info-matricula", { attrs: { imovel: _vm.imovel } }),
      _c("info-dados-titulo", { attrs: { imovel: _vm.imovel } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6b69dda8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b69dda8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/informacoesCadastro/cadastrosOnline/solicitacaoInformacao/InformacoesImovelSolicitacao.vue
// module id = null
// module chunks = 